import { trackPose, TRACK_LENGTH, STRAIGHT_LENGTH, CURVE_RADIUS } from './track.js';

const clamp = value => Math.max(0, Math.min(1, value));
export const ease = value => { const u = clamp(value); return u ** 3 * (10 + u * (-15 + 6 * u)); };
const bendStart = 420, bendForward = 260, bendOffset = 110;
const resolution = 4096;
const arcs = new Float64Array(resolution + 1);
let previousX = 0, previousZ = 0;
for (let i = 1; i <= resolution; i++) {
  const u = i / resolution, x = bendOffset * ease(u), z = bendForward * u;
  arcs[i] = arcs[i - 1] + Math.hypot(x - previousX, z - previousZ);
  previousX = x; previousZ = z;
}
const bendLength = arcs[resolution];

function sPose(distance, lane = 0) {
  if (distance <= bendStart) return { x: lane, y: 0, z: distance, heading: 0 };
  if (distance >= bendStart + bendLength) return { x: bendOffset + lane, y: 0,
    z: bendStart + bendForward + distance - bendStart - bendLength, heading: 0 };
  const s = distance - bendStart;
  let low = 0, high = resolution;
  while (high - low > 1) { const mid = (low + high) >>> 1; if (arcs[mid] < s) low = mid; else high = mid; }
  const u = (low + (s - arcs[low]) / (arcs[high] - arcs[low])) / resolution;
  const heading = Math.atan2(bendOffset * 30 * u * u * (1 - u) ** 2, bendForward);
  return { x: bendOffset * ease(u) + lane * Math.cos(heading), y: 0,
    z: bendStart + bendForward * u - lane * Math.sin(heading), heading };
}

function racingLine(s, version = 6) {
  if (version < 6) return -1.1 * ease((s - 280) / 120) + 2.2 * ease((s - 410) / 95)
    - 2.2 * ease((s - 535) / 105) + 1.9 * ease((s - 660) / 110) - .8 * ease((s - 780) / 130);
  // The first right-hander keeps a restrained exit on the right, leaving room
  // to open the following left. Its later apex feeds the finishing straight.
  return -4.55 * ease((s - 230) / 135) + 7.7 * ease((s - 380) / 115)
    - 7.6 * ease((s - 540) / 120) + 8.9 * ease((s - 660) / 165)
    - 4.45 * ease((s - 855) / 180);
}

export const FLOW_CIRCUIT = Object.freeze({
  id: 'flow-s', length: bendStart + bendLength + 1300, halfWidth: 7,
  curveStart: bendStart, curveEnd: bendStart + bendLength,
  pose: sPose, racingLine,
  curvatureAt: distance => (sPose(distance + .1).heading - sPose(distance - .1).heading) / .2,
});

export const LEGACY_CIRCUIT = Object.freeze({
  id: 'legacy-u', length: TRACK_LENGTH, halfWidth: 10,
  curveStart: STRAIGHT_LENGTH, curveEnd: STRAIGHT_LENGTH + Math.PI * CURVE_RADIUS,
  pose: trackPose, racingLine: () => 0,
  curvatureAt: distance => distance > STRAIGHT_LENGTH && distance < STRAIGHT_LENGTH + Math.PI * CURVE_RADIUS ? 1 / CURVE_RADIUS : 0,
});

export const circuitFor = round => round && round.raceVersion < 5 ? LEGACY_CIRCUIT : FLOW_CIRCUIT;
export const circuitById = id => id === LEGACY_CIRCUIT.id ? LEGACY_CIRCUIT : FLOW_CIRCUIT;
